import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { styled } from '@linaria/react';
export { parameters } from './storybookViewports';
export * from './globalClassNames';
var DEFAULT_SCALAR = 2;
var sevenTwentyScalar = 2 / 3 * 2;
var tenEightyScalar = 2;
var fourKScalar = 4;
export var WebTVBreakpoints = [{
  minWidth: 2160,
  scalar: fourKScalar
}, {
  minWidth: 1920,
  scalar: tenEightyScalar
}, {
  minWidth: 1280,
  scalar: sevenTwentyScalar
}];
export var getBreakpoint = function getBreakpoint(width) {
  return WebTVBreakpoints.find(function (_ref) {
    var minWidth = _ref.minWidth;
    return width >= minWidth;
  });
};
export var GlobalStyles = /*#__PURE__*/styled("div")({
  name: "GlobalStyles",
  class: "gv4nrd2"
});
export var toDP720 = function toDP720(val) {
  return "".concat(val * sevenTwentyScalar, "px");
};
export var toDP1080 = function toDP1080(val) {
  return "".concat(val * tenEightyScalar, "px");
};
export var toDP2160 = function toDP2160(val) {
  return "".concat(val * fourKScalar, "px");
};

var toLinariaCSSRules = function toLinariaCSSRules(styles, cb) {
  return Object.entries(styles).reduce(function (acc, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        rule = _ref3[0],
        value = _ref3[1];

    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, rule, cb(value)));
  }, {});
};

export var toDPQueries = function toDPQueries(styles) {
  return _objectSpread(_objectSpread({}, toLinariaCSSRules(styles, toDP720)), {}, {
    '@media screen and (min-width: 1920px)': toLinariaCSSRules(styles, toDP1080),
    '@media screen and (min-width: 2160px)': toLinariaCSSRules(styles, toDP2160)
  });
};
export var toTransformTranslate = function toTransformTranslate(axis, amount) {
  return {
    transform: "translate".concat(axis, "(").concat(toDP720(amount), ")"),
    '@media screen and (min-width: 1920px)': "translate".concat(axis, "(").concat(toDP1080(amount), ")"),
    '@media screen and (min-width: 2160px)': "translate".concat(axis, "(").concat(toDP2160(amount), ")")
  };
};
/**
 * Converts dp values to the appropriate pixels based on screen size
 * @param val dp value
 */

export var useDP = function useDP(val) {
  var _WebTVBreakpoints$fin;

  if (typeof window === 'undefined') return 2;

  var _ref4 = (_WebTVBreakpoints$fin = WebTVBreakpoints.find(function (_ref5) {
    var minWidth = _ref5.minWidth;
    return window.matchMedia("(min-width: ".concat(minWidth, "px)")).matches;
  })) !== null && _WebTVBreakpoints$fin !== void 0 ? _WebTVBreakpoints$fin : {
    scalar: DEFAULT_SCALAR
  },
      scalar = _ref4.scalar;

  return scalar * val;
};
export var defaultTransition = function defaultTransition() {
  var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;
  var timingFunction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ease';
  return {
    transitionProperty: properties,
    transitionDuration: "".concat(duration, "ms"),
    transitionTimingFunction: timingFunction
  };
};
export var disableAnimations = {
  transition: 'none !important'
};

require("../../../apps/tv/.linaria-cache/packages/@webtv/global-styles/index.linaria.module.css");